import { OPENAI_INTEGRATION } from "./props";
import { useIsFeatureEnabled } from "./useIsFeatureEnabled";

export function useOpenAiIntegration() {
  return useIsFeatureEnabled(OPENAI_INTEGRATION);
}
